import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import { useMemo, useState } from "react";
import styles from "./HistoryDetails.module.scss";
import {
    createDefaultHistoryClassUpdateView,
    defaultHistoryClassDetailsView,
} from "./classes/views/defaultHistoryClassDetailsView";
import {
    HistoryClassCreateDeleteDetailsRow,
    HistoryClassUpdateDetailsRow,
    createHistoryClassCreateDeleteViewConfig,
    createHistoryClassUpdateViewConfig,
} from "./classes/views/historyClassDetailsViewConfig";

interface HistoryClassCreateDeleteDetailsProps {
    data: HistoryClassCreateDeleteDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryClassCreateDeleteDetails: React.FC<
    HistoryClassCreateDeleteDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(defaultHistoryClassDetailsView);
    const viewConfig = useMemo(
        () => createHistoryClassCreateDeleteViewConfig(),
        [],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header="No class changes found" />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};

interface HistoryClassUpdateDetailsProps {
    data: HistoryClassUpdateDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryClassUpdateDetails: React.FC<
    HistoryClassUpdateDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(
        createDefaultHistoryClassUpdateView(),
    );
    const viewConfig = useMemo(
        () => createHistoryClassUpdateViewConfig(data),
        [data],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={viewConfig}
            onViewChange={setView}
            emptyView={() => <EmptyState header="No class changes found" />}
            footer={footer}
            className={styles.historyDetailsView}
        />
    );
};
